import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
let token: any = localStorage.getItem('credentials')
export async function return_form(form:any) {    
    console.log('token',token);
    
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/cancel-sale`, form, {
    }).then(res => {
        console.log('upload res: ', res);
        return res
    })
    // return axios({
    //     url: `https://test.ringel.co/external-sale/cancel-sale`,
    //     data: form,
    //     method: 'POST',
    //     headers: { Authorization: token}
    // })
}